import React from "react";

const Budget = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Budget Allotment</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <p>
          There is no budget allocated by the State Government to the
          Corporation. The Corporation has its own budget and the Budget
          Estimates for the year 2023-24 is as under:-
        </p>

        <div className="table-responsive">
        <table className="table table-striped table-bordered">
            <tbody>
              <tr>
                <th colspan="7" scope="col" className="text-center">
                  BUDGET ESTIMATES 2023-24
                </th>
              </tr>
              <tr>
                <th colspan="7" scope="col" className="text-center">
                  INCOME &amp; EXPENDITURE STATEMENT
                </th>
              </tr>
              <tr>
                <th colspan="7" scope="col" className="text-end">
                  (Rs. In Lac)
                </th>
              </tr>
              <tr>
                <th>S.NO.</th>
                <th>PARTICULARS</th>
                <th>ANNEXURE</th>
                <th>ACTUAL 2021-22</th>
                <th>BUDGET 2022-23</th>
                <th>TENTATIVE 2022-23</th>
                <th>BUDGET 2023-24</th>
              </tr>
              <tr>
                <td>A</td>
                <td>
                  <b>INCOME</b>
                </td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Sale</td>
                <td>A</td>
                <td>8913.14</td>
                <td>13802.67</td>
                <td>8860.94</td>
                <td>15498.78</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Other Income</td>
                <td>B</td>
                <td>305.27</td>
                <td>235.95</td>
                <td>136.06</td>
                <td>144.84</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Closing Stock</td>
                <td>C</td>
                <td>1830.25</td>
                <td>492.71</td>
                <td>368.75</td>
                <td>456.32</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>
                  <b>11048.66</b>
                </td>
                <td>
                  <b>14531.33</b>
                </td>
                <td>
                  <b>9365.75</b>
                </td>
                <td>
                  <b>16099.94</b>
                </td>
              </tr>
              <tr>
                <td>B</td>
                <td>
                  <b>EXPENDITURE</b>
                </td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Opening Stock</td>
                <td>D</td>
                <td>1080.46</td>
                <td>1830.25</td>
                <td>1830.25</td>
                <td>368.75</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Purchase</td>
                <td>E</td>
                <td>7474.94</td>
                <td>9557.81</td>
                <td>4834.26</td>
                <td>12396.34</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Employee Benefit Expenses</td>
                <td>F</td>
                <td>1758.56</td>
                <td>1757.20</td>
                <td>1858.35</td>
                <td>1975.50</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Other Expenses</td>
                <td>G</td>
                <td>451.36</td>
                <td>663.85</td>
                <td>402.62</td>
                <td>656.93</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Selling &amp; Distribution Expenses</td>
                <td>H</td>
                <td>204.10</td>
                <td>296.50</td>
                <td>201.73</td>
                <td>388.50</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Financial Expenses</td>
                <td>I</td>
                <td>184.75</td>
                <td>175.00</td>
                <td>49.44</td>
                <td>120.00</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>
                  <b>11154.17</b>
                </td>
                <td>
                  <b>14280.61</b>
                </td>
                <td>
                  <b>9176.65</b>
                </td>
                <td>
                  <b>15906.02</b>
                </td>
              </tr>
              <tr>
                <td>C</td>
                <td>Profit before depreciation</td>
                <td>&nbsp;</td>
                <td>-105.51</td>
                <td>250.72</td>
                <td>189.10</td>
                <td>193.91</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Depreciation</td>
                <td>&nbsp;</td>
                <td>115.00</td>
                <td>125.00</td>
                <td>110.00</td>
                <td>110.00</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Net profit before tax</td>
                <td>&nbsp;</td>
                <td>
                  <b>-220.51</b>
                </td>
                <td>
                  <b>125.72</b>
                </td>
                <td>
                  <b>79.10</b>
                </td>
                <td>
                  <b>83.91</b>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Taxes</td>
                <td>L</td>
                <td>
                  <b>0.00</b>
                </td>
                <td>
                  <b>39.22</b>
                </td>
                <td>
                  <b>24.68</b>
                </td>
                <td>
                  <b>26.18</b>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>Net profit after tax</td>
                <td>&nbsp;</td>
                <td>
                  <b>-220.51</b>
                </td>
                <td>
                  <b>86.50</b>
                </td>
                <td>
                  <b>54.42</b>
                </td>
                <td>
                  <b>57.73</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Budget;
